export const MAIN_TABS = {
  LOG_BOOK: "logbook",
  REPORTS: "reports",
  TRAINING: "training",
  PROFILE: "profile",
  ADMIN:"admin",
  FORBIDDEN:"forbidden"
};

export const ENDORSEMENT_TEMPLATES = [
  { id: 0, name: "Custom Endorsement" },
  { id: 1, name: "Pre-solo aeronautical knowledge: §61.87(b)" },
  { id: 2, name: "Pre-solo flight training: §61.87(c)(1) and (2)" },
  { id: 3, name: "Pre-solo flight training at night: §61.87(o)" },
  { id: 4, name: "Solo flight (first 90 calendar-day period): §61.87(n)" },
  {
    id: 5,
    name: "Solo flight (each additional 90 calendar-day period): §61.87(p)",
  },
  {
    id: 6,
    name: "Solo take-offs and landings at another airport within 25NM: §61.93(b)(1)",
  },
  { id: 7, name: "Solo flight in Class B airspace: §61.95(a)" },
  {
    id: 8,
    name: "Solo flight to, from, or at an airport located in Class B airspace: §61.95(b) and 14 CFR part 91, §91.131(b)(1)",
  },
  {
    id: 9,
    name: "Endorsement of U.S. citizenship recommended by the Transportation Security Administration (TSA): 49 CFR §1552.3(h)",
  },
  { id: 10, name: "Solo cross-country flight: §61.93(c)(1) and (2)" },
  {
    id: 11,
    name: "Repeated solo cross-country flights not more than 50NM from the point of departure: §61.93(b)(2)",
  },
  { id: 12, name: "Solo cross-country flight: §61.93(c)(3)" },
  {
    id: 13,
    name: "Aeronautical knowledge test: §61.35(a)(1), 61.103(d), 61.105",
  },
  {
    id: 14,
    name: "Review of deficiencies identified on airman knowledge test: §61.39(a)(6)(iii), as required",
  },
  {
    id: 15,
    name: "Prerequisites for practical test: 14 CFR §61.39(a)(6)(i) and (ii)",
  },
  {
    id: 16,
    name: "Flight proficiency/practical test: §61.103(f), 61.107(b), 61.109",
  },
  {
    id: 17,
    name: "Aeronautical knowledge test: §61.35(a)(1), 61.103(d), 61.105",
  },
  {
    id: 18,
    name: "Review of deficiencies identified on airman knowledge test: §61.39(a)(6)(iii), as required",
  },
  {
    id: 19,
    name: "Prerequisites for practical test: 14 CFR §61.39(a)(6)(i) and (ii)",
  },
  {
    id: 20,
    name: "Flight proficiency/practical test: §61.103(f), 61.107(b), 61.109",
  },
  {
    id: 21,
    name: "Retesting after failure of a knowledge or practical test: §61.49",
  },
  { id: 22, name: "Completion of a flight review: §61.56(a) and (c)" },
  {
    id: 23,
    name: "To act as pilot in command in a high-performance airplane: §61.31(f)",
  },
  {
    id: 24,
    name: "To act as pilot in command in a complex airplane: §61.31(e)",
  },
  {
    id: 25,
    name: "To act as pilot in command in a tailwheel airplane: §61.31(i)",
  },
  {
    id: 26,
    name: "To act as pilot in command in a complex airplane: §61.31(e)",
  },
  {
    id: 27,
    name: "To act as pilot in command in a tailwheel airplane: §61.31(i)",
  },
  {
    id: 28,
    name: "To act as pilot in command in a tailwheel airplane: §61.31(i)",
  },
];

export const FLIGHT_STATUS = {
  PENDING: 0,
  APPROVED: 1,
  CANCELLED: 2,
};

export const USER_TYPES = {
  STUDENTS: "students",
  INSTRUCTORS: "instructors",
};

export const TOAST_TYPES = {
  ERROR: "error",
  SUCCESS: "success",
};

export const DEFAULT_TOAST_SHOW_DURATION = 2000;

export const ROLES = {
  STUDENT: "student",
  INSTRUCTOR: "instructor",
};

export const REQUEST_TYPES = {
  ENDORSEMENT: "endorsement",
  FLIGHT: "flight",
  RATING: "rating",
};

export const API_STATUS = {
  IDEAL: "ideal",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

export const RATING_TYPES: any = {
  private_pilot: {
    label: "Private Pilot Ratings",
    models: {
      single_engine: "Airplane, Single-Engine",
      multi_engine: "Airplane, Multi-Engine",
    },
  },
  instrument: {
    label: "Instrument Ratings",
    models: {
      airplane: "Airplane",
      airplane_142_training: "Airplane (Part 142 Training)",
    },
  },
  commercial: {
    label: "Commercial Ratings",
    models: {
      single_engine_land: "Airplane, Single-Engine",
      multi_engine_land: "Airplane, Multi-Engine",
    },
  },
  dpe: {
    label: "DPE Ratings",
    models: {
      single_engine_land: "Airplane, Single-Engine",
      multi_engine_land: "Airplane, Multi-Engine",
    },
  },
  cfi: {
    label: "CFI Ratings",
    models: {
      single_engine_land: "Airplane, Single-Engine land",
      multi_engine_land: "Airplane, Multi-Engine land",
    },
  },
};

export const NOTIFICATION_TYPES = {
  INVITATION_REQUEST: "INVITATION_REQUEST",
  ENDORSEMENT_REQUEST: "ENDORSEMENT_REQUEST",
  FLIGHT_REQUEST: "FLIGHT_REQUEST",
};
